"use strict";
var _array_like_to_array = require("./_array_like_to_array.cjs");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array._(arr);
}
exports._ = _array_without_holes;
